import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import {
  UncontrolledTooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
} from "reactstrap";
import SimpleBar from "simplebar-react";

//Redux
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

// Moment
import moment from "moment";

// Theme style
import "./lightTheme.scss";

// actions
import { vgRemoveAllMessages } from "../../../../store/signalr/actions";

import ProfilePicture from "../../../Common/ProfilePicture";

const NotificationDropdown = ({ t }) => {
  const { chats: messagesSignalR } = useSelector((state) => state.SignalR);

  const dispatch = useDispatch();

  const [menu, setMenu] = useState(false);
  const [selectedChatId, setSelectedChatId] = useState(false);

  const messagesNotifications = useSelector((state) => state.SignalR.chats);
  const { messageOperator } = useSelector((state) => state.Operator);

  const toggle = () => {
    setMenu(!menu);
  };

  const getSender = (chat, msg) => {
    let agent = chat?.users
      ? chat?.users?.filter((e) => e?.id === msg?.userId)
      : [];
    agent = agent && agent.length > 0 ? agent[0]?.name : null;

    return msg?.systemMessage
      ? t("System message")
      : msg?.userId
      ? agent
        ? agent
        : t("Agent")
      : chat?.consumer?.name;
  };

  const getChatInfo = (chatId) => {
    let chats = messageOperator?.chats?.data;
    let aux = chats;
    let pos = "";

    pos =
      chats?.length > 0
        ? chats.map((e) => {
            if (e?.conversationId === chatId) return chats.indexOf(e);
            else return null;
          })
        : null;
    pos = pos && Array.isArray(pos) && pos.filter((e) => e !== null)[0];

    if (pos !== null && pos !== undefined) {
      return aux[pos];
    }
  };

  const totalUnread = () => {
    let total = 0;
    Object.entries(messagesNotifications).forEach(
      (chat) => (total += chat[1].length)
    );

    return total;
  };

  const removeNtofication = () => {
    if (Object.keys(messagesSignalR).length > 0) {
      dispatch(vgRemoveAllMessages());
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada"></i>
          {Object.keys(messagesNotifications).length > 0 && (
            <span className="badge badge-danger badge-pill">
              {totalUnread()}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0" right>
          <div className="p-3">
            <Row className="align-items-center">
              <Col sm="10">
                <h6 className="m-0"> {t("Notifications")} </h6>
              </Col>
              <Col sm="2" className="text-right">
                <i
                  className="fas fa-trash-alt pointer"
                  id="deleteNotification"
                  onClick={() => removeNtofication()}
                ></i>
              </Col>

              <UncontrolledTooltip
                placement="bottom"
                target="deleteNotification"
                className="uncontrolledTooltip"
              >
                {t("Remove notifications")}
              </UncontrolledTooltip>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {Object.entries(messagesNotifications).map((chat, key1) =>
              chat[1].map((item, key2) => (
                <div
                  key={`${key1}-${key2}`}
                  onClick={() => setSelectedChatId(chat[0])}
                  className="text-reset notification-item pointer"
                >
                  <div className="d-flex px-3 py-2 mb-2 notification-bar">
                    <div className="mr-3">
                      <ProfilePicture
                        name={
                          item.userId
                            ? getSender(getChatInfo(chat[0]))
                            : getChatInfo(chat[0])?.consumer?.name
                            ? getChatInfo(chat[0])?.consumer?.name
                            : t("Client")
                        }
                        sizePx={40}
                        style={{
                          left: "39px",
                          top: "42px",
                          textShadow: "2px 2px black",
                        }}
                      />
                    </div>
                    <div className="flex-column align-self-start flex-grow-1">
                      <div className="d-flex customWidth">
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1">
                            {item.userId
                              ? getSender(getChatInfo(chat[0]))
                              : getChatInfo(chat[0])?.consumer?.name ??
                                t("Client")}
                          </h6>
                        </div>

                        <div className="">
                          <i className="mdi mdi-clock-outline mr-1"></i>
                          {moment(item?.sentTime).format("HH:mm:ss")}
                        </div>
                      </div>
                      <div className="font-size-12 text-muted mt-1 customWidth autoEllipse">
                        {item.text}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
            {/* <Link to=""className="text-reset notification-item">
                <div className="media">
                  <img src={avatar4} className="mr-3 rounded-circle avatar-xs"alt="user-pic"/>
                  <div className="media-body">
                    <h6 className="mt-0 mb-1">Salena Layfield</h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">{t('As a skeptical Cambridge friend of mine occidental') + "."}</p>
                      <p className="mb-0"><i className="mdi mdi-clock-outline"></i>{t('1 hours ago')} </p>
                    </div>
                  </div>
                </div>
              </Link> */}
          </SimpleBar>
          <div className="p-2 border-top">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/chats"
            >
              <div>{t("View all")}</div>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
      {selectedChatId && (
        <Redirect
          to={{
            pathname: "/chats",
            state: {
              chatId: selectedChatId,
            },
          }}
        />
      )}
    </React.Fragment>
  );
};
// }
export default withTranslation()(NotificationDropdown);
